// AUTO-GENERATED — clay vite env init (do not edit)
// 2026-10-19T21:08:40.663Z
;(function clayViteEnvInit() {
  if (typeof window === "undefined") return;

  var fromKiln = window.kiln && window.kiln.preloadData && window.kiln.preloadData._envVars;
  var existing = window.process && window.process.env;

  var source = (fromKiln && typeof fromKiln === "object")
    ? fromKiln
    : ((existing && typeof existing === "object") ? existing : {});

  window.process = window.process || {};
  window.process.env = Object.assign({}, source, window.process.env || {});
}());
